import { defineSlotRecipe } from '@chakra-ui/react';

export const cssTooltipSlotRecipe = defineSlotRecipe({
    className: 'css-tooltip',
    slots: ['root', 'content'],
    base: {
        root: {
            position: 'relative',
            '&:hover .tooltip-content': {
                opacity: 1,
                visibility: 'visible',
            },
        },
        content: {
            opacity: 0,
            visibility: 'hidden',
            position: 'absolute',
            bottom: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            mb: 2,
            bg: 'gray.950',
            color: 'white',
            p: 2,
            borderRadius: 'sm',
            fontSize: 'xs',
            lineHeight: '1.2',
            whiteSpace: 'nowrap',
            zIndex: 'tooltip',
            pointerEvents: 'none',
            transition: 'all 0.2s ease-in-out',
            _after: {
                content: '""',
                position: 'absolute',
                top: '100%',
                left: '50%',
                transform: 'translateX(-50%)',
                border: '5px solid transparent',
                borderTopColor: 'gray.900',
            },
        },
    },
});
